import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { resolveParamsForS3 } from "../service-customizations";
import { createConfigValueProvider } from "./createConfigValueProvider";
import { getEndpointFromConfig } from "./getEndpointFromConfig";
import { toEndpointV1 } from "./toEndpointV1";
export var getEndpointFromInstructions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(commandInput, instructionsSupplier, clientConfig, context) {
    var endpointFromConfig, endpointParams, endpoint;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (clientConfig.endpoint) {
              _context.next = 11;
              break;
            }
            if (!clientConfig.serviceConfiguredEndpoint) {
              _context.next = 7;
              break;
            }
            _context.next = 4;
            return clientConfig.serviceConfiguredEndpoint();
          case 4:
            endpointFromConfig = _context.sent;
            _context.next = 10;
            break;
          case 7:
            _context.next = 9;
            return getEndpointFromConfig(clientConfig.serviceId);
          case 9:
            endpointFromConfig = _context.sent;
          case 10:
            if (endpointFromConfig) {
              clientConfig.endpoint = function () {
                return Promise.resolve(toEndpointV1(endpointFromConfig));
              };
            }
          case 11:
            _context.next = 13;
            return resolveParams(commandInput, instructionsSupplier, clientConfig);
          case 13:
            endpointParams = _context.sent;
            if (!(typeof clientConfig.endpointProvider !== "function")) {
              _context.next = 16;
              break;
            }
            throw new Error("config.endpointProvider is not set.");
          case 16:
            endpoint = clientConfig.endpointProvider(endpointParams, context);
            return _context.abrupt("return", endpoint);
          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getEndpointFromInstructions(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export var resolveParams = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(commandInput, instructionsSupplier, clientConfig) {
    var _instructionsSupplier;
    var endpointParams, instructions, _i, _Object$entries, _Object$entries$_i, name, instruction;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            endpointParams = {};
            instructions = (instructionsSupplier === null || instructionsSupplier === void 0 ? void 0 : (_instructionsSupplier = instructionsSupplier.getEndpointParameterInstructions) === null || _instructionsSupplier === void 0 ? void 0 : _instructionsSupplier.call(instructionsSupplier)) || {};
            _i = 0, _Object$entries = Object.entries(instructions);
          case 3:
            if (!(_i < _Object$entries.length)) {
              _context2.next = 20;
              break;
            }
            _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), name = _Object$entries$_i[0], instruction = _Object$entries$_i[1];
            _context2.t0 = instruction.type;
            _context2.next = _context2.t0 === "staticContextParams" ? 8 : _context2.t0 === "contextParams" ? 10 : _context2.t0 === "clientContextParams" ? 12 : _context2.t0 === "builtInParams" ? 12 : 16;
            break;
          case 8:
            endpointParams[name] = instruction.value;
            return _context2.abrupt("break", 17);
          case 10:
            endpointParams[name] = commandInput[instruction.name];
            return _context2.abrupt("break", 17);
          case 12:
            _context2.next = 14;
            return createConfigValueProvider(instruction.name, name, clientConfig)();
          case 14:
            endpointParams[name] = _context2.sent;
            return _context2.abrupt("break", 17);
          case 16:
            throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
          case 17:
            _i++;
            _context2.next = 3;
            break;
          case 20:
            if (Object.keys(instructions).length === 0) {
              Object.assign(endpointParams, clientConfig);
            }
            if (!(String(clientConfig.serviceId).toLowerCase() === "s3")) {
              _context2.next = 24;
              break;
            }
            _context2.next = 24;
            return resolveParamsForS3(endpointParams);
          case 24:
            return _context2.abrupt("return", endpointParams);
          case 25:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function resolveParams(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();